export default __webpack_public_path__ + "21081aae940cec8cf3f5254005e07c07.png";